import { ActionReducerMapBuilder } from '@reduxjs/toolkit'

import { getTikTokFollowWelcomeMessageState } from 'apps/tiktokFollowWelcome/adapter'
import { TikTokFollowWelcomeState } from 'apps/tiktokFollowWelcome/interfaces'
import {
  MESSAGE_DISABLED_TEXT,
  MESSAGE_ENABLED_TEXT,
  NAMESPACE,
} from 'apps/tiktokFollowWelcome/store/constants'
import { alert } from 'common/core'
import { tiktokApi } from 'shared/api/requests/tiktok'
import { createAsyncAction } from 'shared/lib/redux'

const switchApi = tiktokApi.tikTokFollowWelcome.switch

export const toggleTikTokMessage = createAsyncAction(
  `${NAMESPACE}/toggleMessage`,
  async (enabled: boolean) => {
    const updatedData = await tiktokApi.tikTokFollowWelcome.switch({ body: { enabled } })
    const messageState = getTikTokFollowWelcomeMessageState(updatedData.data.follow_welcome)

    alert(messageState.messageEnabled ? MESSAGE_ENABLED_TEXT() : MESSAGE_DISABLED_TEXT(), 'success')

    return messageState
  },
  {
    autoHandleByGuards: [switchApi.isStatusUpdateFailedError],
  },
)

export const toggleTikTokMessageReducer = (
  builder: ActionReducerMapBuilder<TikTokFollowWelcomeState>,
) => {
  builder
    .addCase(toggleTikTokMessage.pending, (state) => ({ ...state, isMessageToggling: true }))
    .addCase(toggleTikTokMessage.rejected, (state) => ({ ...state, isMessageToggling: false }))
    // Only its own field, so a save running at the same time keeps its text
    .addCase(toggleTikTokMessage.fulfilled, (state, action) => ({
      ...state,
      messageEnabled: action.payload.messageEnabled,
      isMessageToggling: false,
    }))
}
